<template>
  <div>
    <b-card no-body>
      <b-row>
        <b-col cols="12">
          <b-row class="pb-1 mt-50">
            <b-col class="text-left" cols="5">
              <b-button class="btn-sm mr-50 ml-50" variant="primary" @click="New()">
                <feather-icon class="align-text-top" icon="PlusIcon" size="16"/>
                Thêm mới
              </b-button>
              <b-button class="btn-sm" variant="primary" @click="Deletes()">
                <feather-icon class="align-text-top" icon="DeleteIcon" size="16"/>
                Xóa
              </b-button>
            </b-col>
            <b-col class="text-right" cols="6">
              <b-button class="btn-sm mr-50" variant="primary" @click="$refs.fileInput.click()">
                <feather-icon class="align-text-top" icon="ImportIcon" size="16"/>
                Nhập file
              </b-button>
              <input id="fileInput" ref="fileInput" style="display:none;" type="file" @change="importFile">
              <b-button class="btn-sm mr-50" variant="primary" @click="ExportTemp()">
                <feather-icon class="align-text-top" icon="ExortIcon" size="16"/>
                Tải file mẫu
              </b-button>
              <b-button class="btn-sm " variant="primary" @click="ExportFile()">
                <feather-icon class="align-text-top" icon="ExortIcon" size="16"/>
                Xuất file
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <vue-good-table :columns="options.fields" :isLoading.sync="isLoading" :line-numbers="true" :pagination-options="{ perPage: serverParams.pageSize, enabled: true, perPageDropdown: [20, 50, 100], dropdownAllowAll: false }"
                              :rows="items" :select-options="{ enabled: true }"
                              :totalRows="totalRecords"
                              mode="remote" @on-page-change="onPageChange"
                              @on-sort-change="onSortChange"
                              @on-column-filter="onColumnFilter"
                              @on-per-page-change="onPerPageChange" @on-selected-rows-change="selectionChanged">
                <template slot="table-row" slot-scope="props">
                  <!-- Column: Action -->
                  <span v-if="props.column.field === 'action'">
                    <span>
                      <b-button class="btn-icon" size="sm" variant="primary" @click="Edit(props.row, props.row.id)">
                        <feather-icon icon="Edit2Icon"/>
                      </b-button>
                      <b-button class="btn-icon" size="sm" style="margin-left: 6px" variant="danger"
                                @click="DeleteItem(props.row, props.row.id)">
                        <feather-icon icon="TrashIcon"/>
                      </b-button>
                    </span>
                  </span>
                </template>
              </vue-good-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>

    <b-modal id="modal-edit" :title="getTitle()" size="xl" @ok="handleOk">
      <b-row>
        <b-col cols="3">
          <b-form-group label="Danh mục">
            <Select2 v-model="currentItem.category_id" :options="categoryList" v-bind:class="{ 'readonly': editMode, '': !editMode }"
                     v-on:change="catOnChange"/>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="Chủ đề">
            <Select2 v-model="currentItem.topic_id" :options="topicList"/>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group>
            <label>Trạng thái<span class='text-danger'>*</span></label>
            <Select2 v-model="currentItem.status" :options="statusList" :state="validateState('status')" minlength="3"
                     required/>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group>
            <label>Ngày hiệu lực<span class='text-danger'>*</span></label>
            <b-form-input v-model="currentItem.effect_date" :state="validateState('effect_date')" placeholder="Ngày hiệu lực" required
                          type="date"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-form-group>
            <label>Nội dung câu hỏi/tình huống<span class='text-danger'>*</span></label>
            <!-- <b-form-textarea id="textarea-auto-height" placeholder="Nội dung câu hỏi/tình huống" rows="3"
              v-model="currentItem.question" max-rows="3" :state="validateState('question')" required /> -->
            <ckeditor v-model="currentItem.question" :config="editorConfig" :editor-url="editorUrl"
                      :state="validateState('question')" class="editor-form" placeholder="Nội dung câu hỏi/tình huống"></ckeditor>

          </b-form-group>
        </b-col>
        <b-col class="mt-50 text-left" cols="12">
          <b-form-group>
            <div v-if="currentItem && currentItem.question_file">
              <b-button class="btn-icon" size="sm" style="margin-left: 6px" variant="danger" @click="removeFile()">
                <feather-icon icon="TrashIcon"/>
              </b-button>
              <lable>{{ currentItem.question_file }}</lable>
            </div>
            <div class="clearfix mb-0 mt-50"></div>
            <b-form-file v-model="currentItem.fileQuest" accept="application/pdf,application/vnd.ms-excel,application/csv,application/vnd.openxmlformats-officedocument.wordprocessingml.document" plain
                         v-on:input="uploadFileQuest">
            </b-form-file>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <label>Nội dung câu trả lời<span class='text-danger'>*</span></label>
          <!-- <b-form-textarea id="textarea-auto-height" placeholder="Nội dung câu trả lời" rows="3"
            v-model="currentItem.answer" max-rows="3" :state="validateState('answer')" required /> -->
          <ckeditor v-model="currentItem.answer" :config="editorConfig" :editor-url="editorUrl"
                    :state="validateState('answer')" class="editor-form" placeholder="Nội dung câu trả lời"></ckeditor>

        </b-col>
        <b-col class="mt-50 text-left" cols="12">
          <b-form-group>
            <div v-if="currentItem && currentItem.answer_file">
              <b-button class="btn-icon" size="sm" style="margin-left: 6px" variant="danger"
                        @click="removeFileAnswer()">
                <feather-icon icon="TrashIcon"/>
              </b-button>
              <lable>{{ currentItem.answer_file }}</lable>
            </div>
            <div class="clearfix mb-0 mt-50"></div>

            <b-form-file v-model="currentItem.fileAnswer" accept="application/pdf,application/vnd.ms-excel,application/csv,application/vnd.openxmlformats-officedocument.wordprocessingml.document" plain
                         v-on:input="uploadFileAnswer">
            </b-form-file>
          </b-form-group>
        </b-col>

      </b-row>
      <b-row>
        <b-col cols="12">
          <label>Nguyên nhân</label>
          <!-- <b-form-textarea id="textarea-auto-height" placeholder="Nguyên nhân" rows="3" v-model="currentItem.reason"
            max-rows="3" :state="validateState('reason')" required /> -->
          <ckeditor v-model="currentItem.reason" :config="editorConfig" :editor-url="editorUrl"
                    :state="validateState('reason')" class="editor-form" placeholder="Nguyên nhân"></ckeditor>

        </b-col>
        <b-form-group>
          <div v-if="currentItem && currentItem.reason_file">
            <b-button class="btn-icon" size="sm" style="margin-left: 6px" variant="danger" @click="removeFileReason()">
              <feather-icon icon="TrashIcon"/>
            </b-button>
            <lable>{{ currentItem.reason_file }}</lable>
          </div>
          <div class="clearfix mb-0 mt-50"></div>
          <b-form-file v-model="currentItem.fileReason" accept="application/pdf,application/vnd.ms-excel,application/csv,application/vnd.openxmlformats-officedocument.wordprocessingml.document" plain
                       v-on:input="uploadFileReason">
          </b-form-file>
        </b-form-group>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import vSelect from "vue-select";
import {VueGoodTable} from "vue-good-table";
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTable,
  BTooltip
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "@core/scss/vue/libs/vue-good-table.scss";
import Select2 from "v-select2-component";
import {getuserName, TypeCategories} from '@/@core/utils/utils';
import Vue from 'vue';
import CKEditor from 'ckeditor4-vue';

Vue.use(CKEditor);

export default {
  name: "adminTopic",
  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BFormTextarea,
    BInputGroup, BInputGroupAppend,
    BFormFile
  },
  methods: {
    getTitle() {
      if (this.editMode) {
        return "Cập nhật Q&A ";
      } else {
        return "Thêm mới Q&A ";
      }
    },
    validateState(pro) {
      if (!this.isSubmit) return null;
      if (!this.currentItem[pro]) return false;
      else return true;
      return null;
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },
    onPerPageChange(params) {
      this.updateParams({pageSize: params.currentPerPage});
      this.loadItems();
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.serverParams.page = 1;
      this.updateParams(params);
      console.log(this.serverParams);
      this.loadItems();
    },

    loadItems() {
      try {
        this.loading(true);
        let data = {
          ...this.serverParams,
          columnFilters: {
            ...(this.serverParams.columnFilters ? this.serverParams.columnFilters : [])
          }
        }
        if (data.columnFilters.created_date != undefined) {
          delete data.columnFilters['created_date_']
        }
        useJwt
            .post("portal/QAs", data)
            .then((response) => {
              this.items = response.data.result;
              this.totalRecords = response.data.totalRecords;
              this.isLoading = false;
              this.loading(false);
            });
      } catch (ex) {
        this.loading(false);
      }
    },

    New() {
      this.currentItem = {};
      this.editMode = false;
      this.modal_title = "Thêm mới Q&A ";
      this.$bvModal.show("modal-edit");
    },

    async Edit(item) {
      this.currentItem = item;
      this.editMode = true;
      this.modal_title = "Cập nhật Q&A";
      this.$bvModal.show("modal-edit");
    },

    async DeleteItem(item, index, button) {
      this.currentItem = item;
      const url = `portal/QA/${item.id}`;
      let resModal = await this.$bvModal.msgBoxConfirm(
          "Vui lòng xác nhận bạn muốn xoá dữ liệu Q&A",
          {title: "Please Confirm", size: "sm"}
      );
      if (resModal) {
        try {
          this.loading(true);
          let res = await useJwt.delete(url);
          this.loading(false);
          if (res.data.code == 200) {
            this.loadItems();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Xoá Q&A thành công!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          }
        } catch (error) {
          this.loading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi xoá Q&A ",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      }
    },
    selectionChanged(params) {
      this.rowSelection = params.selectedRows;
    },
    async Deletes() {
      if (this.rowSelection.length == 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Bạn phải chọn dữ liệu cần xóa. Xin vui lòng kiểm tra lại!",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return;
      }
      let resModal = await this.$bvModal.msgBoxConfirm(
          "Vui lòng xác nhận bạn muốn xoá dữ liệu Q&A",
          {title: "Please Confirm", size: "sm"}
      );

      if (resModal) {
        const listId = [];
        for (var i = 0; i < this.rowSelection.length; i++) {
          listId.push(this.rowSelection[i].id);
        }
        const createParams = {
          ids: listId.join(',')
        };
        try {
          this.loading(true);
          const res = await useJwt.post("portal/deleteQAs", createParams);
          this.loading(false);
          if (res.data.code == 200) {
            this.isSubmit = false;
            this.loadItems();
            return this.$toast({
              component: ToastificationContent,
              props: {
                title: "Xóa Q&A thành công!",
                icon: "CheckSquareIcon",
                variant: "success",
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: res.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        } catch (error) {
          this.loading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi xóa Q&A ",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      }
    },
    async loadCategories() {
      useJwt.get("portal/getAllCategories").then((response) => {
        var result = response.data;
        if (result.code == 200) {
          this.categoryList = [];
          this.topicList = [];
          this.topicAll = [];
          result.result.forEach(item => {
            if (item.cat_type == 0 && item.cat_type_new == TypeCategories.QA) {
              this.categoryList.push({'id': item.id, 'text': item.name});
            } else if (item.cat_type_new == TypeCategories.QA) {
              this.topicAll.push({'id': item.id, 'text': item.name, 'parent_id': item.parent_id});
              this.topicList.push({'id': item.id, 'text': item.name, 'parent_id': item.parent_id});
            }
          });
        }

        this.isLoading = false;
        this.loading(false);
      });
    },

    onUpload(e) {
      try {
        this.loading(true);
        if (!e.target.files || !e.target.files[0]) return;
        const that = this;
        const FR = new FileReader();
        FR.addEventListener("load", function (evt) {
          that.currentItem.qrimage = evt.target.result
        });
        FR.readAsDataURL(e.target.files[0]);
      } catch {
        this.loading(false);
      }

    },
    async handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      const userName = getuserName();
      const bIsValid = await this.isValidQA(this.currentItem);
      if (!bIsValid) {
        return;
      }
      if (this.editMode) {
        const url = `portal/QA/${this.currentItem.id}`;
        const updateParams = {
          id: this.currentItem.id,
          category_id: this.currentItem.category_id,
          topic_id: this.currentItem.topic_id,
          name: this.currentItem.name,
          status: this.currentItem.status,
          effect_date: this.currentItem.effect_date,
          question: this.currentItem.question,
          question_file: this.currentItem.question_file,
          answer: this.currentItem.answer,
          answer_file: this.currentItem.answer_file,
          reason: this.currentItem.reason,
          reason_file: this.currentItem.reason_file,
          created_at: userName,
          updated_at: userName
        };
        try {
          this.loading(true);
          const res = await useJwt.put(url, updateParams);
          this.loading(false);
          if (res.data.code == 200) {
            this.loadItems();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Cập nhật thành công!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
            this.$bvModal.hide("modal-edit");
            return;
          }
        } catch (error) {
          this.loading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi thêm mới Q&A ",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return
        }
      }
      try {
        const createParams = {
          id: 0,
          category_id: this.currentItem.category_id,
          topic_id: this.currentItem.topic_id,
          name: this.currentItem.name,
          status: this.currentItem.status,
          effect_date: this.currentItem.effect_date,
          question: this.currentItem.question,
          question_file: this.currentItem.question_file,
          answer: this.currentItem.answer,
          answer_file: this.currentItem.answer_file,
          reason: this.currentItem.reason,
          reason_file: this.currentItem.reason_file,
          created_at: userName,
          updated_at: userName
        };
        this.loading(true);
        const res = await useJwt.post("portal/QA", createParams);
        if (res.data.code == 200) {
          this.loadItems();
          this.$bvModal.hide("modal-edit");
          return this.$toast({
            component: ToastificationContent,
            props: {
              title: "Thêm mới Q&A thành công!",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        }
      } catch (error) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi thêm mới Q&A ",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    async isValidQA(item) {
      if (item.status == null || item.status === '' || item.status == undefined) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Trạng thái không được để trống.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      }

      if (!item.question) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Nội dung câu hỏi không được để trống",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      }
      if (!item.answer) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Nội dung câu trả lời không được để trống",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      }

      return true;
    },
    async quickSearch() {
      this.serverParams.columnFilters.searchQuick = this.searchQuery;
      this.loadItems();
    },
    catOnChange(e) {
      this.topicList = this.topicAll.filter(function (item) {
        return item.parent_id == e
      });
    },
    async uploadFileQuest() {
      try {
        if (!this.currentItem.fileQuest) {
          return;
        }
        this.loading(true);
        var formData = new FormData();
        formData.append("file", this.currentItem.fileQuest);
        const res = await useJwt.post(`portal/upload`, formData);
        if (res.data.code == 200) {
          this.currentItem.question_file = res.data.result;
          this.currentItem.fileQuest = '';
        }
      } catch {
        this.loading(false);
      }

    },
    removeFile() {
      this.currentItem.question_file = '';
      this.currentItem.fileQuest = '';
    },
    async uploadFileAnswer() {
      try {
        if (!this.currentItem.fileAnswer) {
          return;
        }
        this.loading(true);
        var formData = new FormData();
        formData.append("file", this.currentItem.fileAnswer);
        const res = await useJwt.post(`portal/upload`, formData);
        if (res.data.code == 200) {
          this.currentItem.answer_file = res.data.result;
          this.currentItem.fileAnswer = '';
        }
        this.loading(false);
      } catch {
        this.loading(false);
      }
    },
    removeFileAnswer() {
      this.currentItem.answer_file = '';
      this.currentItem.fileAnswer = '';
    },
    async uploadFileReason() {
      try {
        if (!this.currentItem.fileReason) {
          return;
        }
        this.loading(true);
        var formData = new FormData();
        formData.append("file", this.currentItem.fileReason);
        const res = await useJwt.post(`portal/upload`, formData);
        if (res.data.code == 200) {
          this.currentItem.reason_file = res.data.result;
          this.currentItem.fileReason = '';
        }
        this.loading(false);
      } catch {
        this.loading(false);
      }
    },
    removeFileReason() {
      this.currentItem.reason_file = '';
      this.currentItem.fileReason = '';
    },
    async ExportTemp() {
      try {
        this.loading(true);
        await useJwt.getFile("portal/downloadQAfiletemp", 'qa_temp.xlsx');
        this.loading(false);
      } catch (err) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "File không đúng hoặc không còn tồn tại.",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
      }
    },
    async ExportFile() {
      try {
        this.loading(true);
        await useJwt.getFile("portal/downloadQAexcel", 'qa.xlsx');
        this.loading(false);
      } catch (err) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "File không đúng hoặc không còn tồn tại.",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
      }
    },
    async importFile(e) {
      try {
        const fileImport = this.$refs.fileInput.files[0];
        if (fileImport != null) {
          var formData = new FormData();
          formData.append("file", fileImport);
          this.loading(true);
          const res = await useJwt.post("portal/importQAExcel", formData);
          this.loading(false);
          if (res.data.code != 200) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: res.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger"
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Nhập file thành công!",
                icon: "CheckSquareIcon",
                variant: "success",
              },
            });
            this.loadItems();
          }
        }
      } catch (err) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Nhập file thất bại.",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
      }
    }
  },

  mounted() {
    this.isSubmit = false;
    this.loadItems();
    this.loadCategories();
  },
  data() {
    return {
      isLoading: false,
      isSubmit: false,
      totalRecords: 0,
      items: [],
      statusList: [
        {id: 1, text: "Hiệu lực"},
        {id: 0, text: "Hết hiệu lực"}
      ],
      categoryList: [],
      topicList: [],
      topicAll: [],
      editMode: false,
      totalItem: 0,
      searchQuery: "",
      currentItem: {},
      rowSelection: [],
      options: {
        fields: [
          {field: "action", label: "Cài đặt", width: "120px"},
          {
            field: "topicName",
            filterOptions: {enabled: true, placeholder: "", trigger: 'enter'},
            label: "Chủ đề",
            required: true
          },

          {
            field: "question",
            filterOptions: {enabled: true, placeholder: "", trigger: 'enter'},
            label: "Nội dung câu hỏi/ tình huống",
            required: true
          },

          {
            field: "answer",
            filterOptions: {enabled: true, placeholder: "", trigger: 'enter'},
            label: "Nội dung câu trả lời",
            required: true
          },
          {
            field: "reason",
            filterOptions: {enabled: true, placeholder: "", trigger: 'enter'},
            label: "Nguyên nhân (nếu có)",
            required: true
          },
          {
            field: "statusName",
            filterOptions: {enabled: true, placeholder: "", trigger: 'enter'},
            label: "Trạng thái",
            required: true
          },
          {
            field: "effect_date",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Ngày hiệu lực",
            type: 'date',
            dateInputFormat: 'yyyy-MM-dd',
            dateOutputFormat: 'dd/MM/yyyy',
            required: true
          }
        ]
      },
      serverParams: {
        "columnFilters": {},
        "sort": [
          {"field": "created_date", "type": "desc"}
        ],
        "page": 1,
        "pageSize": 20,
        "lang": 1
      },
      editorUrl: 'https://cdn.ckeditor.com/4.20.0/full-all/ckeditor.js',
      editorConfig: {
        extraPlugins: 'tableresize',
        toolbarGroups: [
          {name: 'document', groups: ['mode', 'document', 'doctools']},
          {name: 'clipboard', groups: ['clipboard', 'undo']},
          {name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing']},
          {name: 'forms', groups: ['forms']},
          {name: 'basicstyles', groups: ['basicstyles', 'cleanup']},
          {name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph']},
          {name: 'links', groups: ['links']},
          {name: 'insert', groups: ['insert']},
          {name: 'styles', groups: ['styles']},
          {name: 'colors', groups: ['colors']},
          {name: 'tools', groups: ['tools']},
          {name: 'others', groups: ['others']},
          {name: 'about', groups: ['about']}
        ]
      }
    };
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style>
table.vgt-table td {
  min-width: 100px;
}

.ql-editor {
  min-height: 200px;
}
</style>
